import uuid from 'react-native-uuid';
import { isWeb } from '@helpers';

/**
 * Client-generated annotation id. Stable across saves once the server echoes it back.
 *
 * Web uses native `crypto.randomUUID` (zero-dep, fastest); native falls back to `react-native-uuid`
 * because React Native lacks the Web Crypto API.
 */
export const newAnnotationId = (): string => (isWeb ? crypto.randomUUID() : (uuid.v4() as string));
